import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PosthogService {
    private initialized = false;

    constructor() {
        this.initialize();
    }

    private initialize() {
        try {
            if (!this.initialized && environment.posthog?.key && environment.posthog?.api_host && environment.posthog?.ui_host) {
                posthog.init(environment.posthog.key, {
                    api_host: environment.posthog.api_host,
                    ui_host: environment.posthog.ui_host,
                    defaults: '2025-05-24',
                });
                this.initialized = true;
            }
        } catch (error) {
            console.error('PostHog initialization failed:', error);
        }
    }

    identifyUser(userId: string, userProperties: Record<string, unknown> = {}) {
        if (!this.initialized) {
            return;
        }
        try {
            posthog.identify(userId, userProperties);
        } catch (error) {
            console.error('PostHog identify failed:', error);
        }
    }

    resetUser() {
        if (!this.initialized) {
            return;
        }
        try {
            posthog.reset();
        } catch (error) {
            console.error('PostHog reset failed:', error);
        }
    }

    updatePrimaryCommunityInPosthog(communityId: string, communityName: string) {
        if (!this.initialized) {
            return;
        }
        try {
            posthog.setPersonProperties({
                mainCommunityId: communityId,
                mainCommunityName: communityName,
            });
            posthog.reloadFeatureFlags();
        } catch (error) {
            console.error('PostHog update primary community failed:', error);
        }
    }

    isFeatureEnabled(flagName: string): boolean {
        if (environment.debug) {
            // Force true on debug mode for easier testing
            return true;
        }

        if (!this.initialized) {
            return false;
        }
        try {
            return posthog.isFeatureEnabled(flagName);
        } catch (error) {
            console.error(`PostHog getFeatureFlag failed for ${flagName}:`, error);
            return false;
        }
    }
}
